import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";

export const fetchStatisticsMedicalDesk = createAsyncThunk(
    'contract/fetchStatisticsMedicalDesk',
    async ({ ContractID }: {
        ContractID: string[] | string,
    }, { rejectWithValue }) => {
        try {
            const response = await getRequest({
                "ContractID": ContractID[0]
            }, 'dms-hr', 'getInsuranceContractMedicalDeskStatistics', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { Statistics: data.Statistics };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchStatisticsClientService = createAsyncThunk(
    'contract/fetchStatisticsClientService',
    async ({ ContractID }: {
        ContractID: string[] | string,
    }, { rejectWithValue }) => {
        try {
            const response = await getRequest({
                "ContractID": ContractID[0]
            }, 'dms-hr', 'getInsuranceContractClientService', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { Statistics: data.Statistics };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchCommonStatistics = createAsyncThunk(
    'contract/fetchCommonStatistics',
    async ({ ContractID }: {
        ContractID: string[] | string,
    }, { rejectWithValue }) => {
        try {
            const response = await getRequest({
                "ContractID": ContractID[0]
            }, 'dms-hr', 'getInsuranceContractCommonStatistics', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { Statistics: data.Statistics };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);


// getInsuranceContractClientService -  "Statistics": {
//         "RefusalFrequency": 3.76, - частота отказов
//         "ApprovalBeyondProgramFrequency": 0.19, - согласование спец
//         "ComplaintRate": 0, - уровень жалоб
//         "JustifiedClaimsAmount": 0, - обоснов прет
//         "UnJustifiedClaimsAmount": 0, - не обоснов прет
//         "GratitudesAmount": 2  - благодарностей
//     }

// getInsuranceContractCommonStatistics -   "Statistics": {
//         "InsurancePremium": 5100, - премия
//         "InsuredsAmount": 7, - кол-во 
//         "RotationLevel": 176.47 - ур ротации 
//     }


// getInsuranceContractMedicalDeskStatistics - "Statistics": {
//         "DoctorRequestAmount": 532, -  кол-во обращений
//         "Convertibility": 228.57, - обращаемость
//         "DoctorRequestAmountPerPolicy": 33.25, - обращ на один полис
//         "IssueResolutionOnFirstDoctorRequest": 98.5, - решение с первого обращ
//         "AvgTimeResolutionClinicRegistration": 1.76, - ср время записи
//         "AvgTimeResolutionServiceApproval": 2.18 - ср вр согласов
//     }
